/* eslint-disable react/prop-types */
import React from "react";
import { Avatar, Card } from "antd";
import IsMobileView from "../../components/utils/mobileView";
import { LandingSection } from "./landing-section";

const Testimonials = ({ testimonials }) => {
  const isMobileView = IsMobileView();
  if (!Array.isArray(testimonials) || testimonials.length === 0) {
    return null;
  }
  return (
    <LandingSection title="What Filmmakers Say">
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 24,
          maxWidth: 640,
          margin: "0 auto",
          width: "100%",
        }}
      >
        {testimonials.map((item, index) => (
          <Card className="vc-panel" key={index}>
            <div
              style={{
                display: "flex",
                gap: 16,
                alignItems: "flex-start",
              }}
            >
              {item.image ? (
                <Avatar
                  src={item.image}
                  alt={item.title || ""}
                  size={isMobileView ? 56 : 72}
                  style={{
                    flexShrink: 0,
                    border: "1px solid var(--vc-border)",
                  }}
                />
              ) : (
                <Avatar
                  size={isMobileView ? 56 : 72}
                  style={{
                    flexShrink: 0,
                    background: "var(--vc-border)",
                    color: "var(--vc-text)",
                  }}
                >
                  {(item.title || "?").charAt(0)}
                </Avatar>
              )}
              <div style={{ minWidth: 0, flex: 1 }}>
                <h3
                  style={{
                    color: "var(--vc-text)",
                    fontSize: "20px",
                    lineHeight: 1.3,
                    fontWeight: 700,
                    marginBottom: 8,
                  }}
                >
                  {item.title}
                </h3>
                <p
                  style={{
                    color: "var(--vc-text-muted, rgba(0,0,0,0.65))",
                    margin: 0,
                    lineHeight: 1.6,
                    fontSize: isMobileView ? 14 : 15,
                  }}
                >
                  {item.description}
                </p>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </LandingSection>
  );
};

export default Testimonials;
